import { Injectable } from '@angular/core';
import { UserInit } from '@features/user-init/user-init.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SentryService } from '@rd-lib/sentry/sentry.service';
import { AppInit } from '@rd/app-init/app-init.action';
import { NydusNetworkDataError } from '@rd/errors/nydus-network-data-error';
import { HttpError, LoyaltyProgram } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LoyaltyProgramApiService } from '../../services/loyalty-program-api/loyalty-program-api.service';
import * as actions from '../actions/loyalty-program.actions';

@Injectable()
export class LoyaltyProgramEffects {
  constructor(
    private actions$: Actions,
    private loyaltyProgramApiService: LoyaltyProgramApiService,
    private sentryService: SentryService,
  ) {}

  loadLoyaltyProgramsFromOtherEffects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppInit, UserInit),
      map(() => new actions.LoadLoyaltyPrograms()),
    ),
  );

  loadLoyaltyPrograms$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS),
      switchMap(() => {
        return this.loyaltyProgramApiService.getAllLoyaltyPrograms().pipe(
          map((loyaltyPrograms: LoyaltyProgram[]) => {
            this.checkLoyaltyProgramsIntegrity(loyaltyPrograms);
            return new actions.LoadLoyaltyProgramsSuccess(loyaltyPrograms);
          }),
          catchError((error: HttpError) =>
            of(new actions.LoadLoyaltyProgramsFail(error)),
          ),
        );
      }),
    ),
  );

  private checkLoyaltyProgramsIntegrity(
    loyaltyPrograms: LoyaltyProgram[],
  ): void {
    if (loyaltyPrograms.length === 0) {
      const nydusNetworkDataError = new NydusNetworkDataError({
        httpMethod: 'GET',
        endpoint: '/loyalty_programs',
        message: 'LoyaltyPrograms are empty.',
      });

      this.sentryService.manualError(nydusNetworkDataError.toString());
    }
  }
}
